import { DatePicker, Checkbox, Button, Form, Popover } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { BsCalendar4Event, BsCaretDown } from "react-icons/bs";
import ExportBooking from "./ExportBooking";
import CreateWrapper from "./CreateWrapper";
import { Link } from "react-router-dom";
import fetchAllSites from "../../../../services/fetchAllSites";

const { RangePicker } = DatePicker;

export default function BookingHeader({
  stateHandler,
  siteHandler,
  bookings,
  inManage,
  handleFetchBookings,
  site,
}: any) {
  const [sites, setSites] = useState<any>([]);
  const [type, setType] = useState<any>({
    id: 1,
    name: "All Service Types",
    value: "",
  });
  const [showRange, setShowRange] = useState(false);
  const [form] = Form.useForm();
  const [filters, setFilters] = useState<any>({
    startDate: moment(new Date()),
    endDate: moment(new Date()),
    type: "",
    isAll: false,
  });

  const [isFiltered, setFiltered] = useState<boolean>(false);

  const [option, setOption] = useState<any>({
    id: 1,
    name: "Today",
    startDate: moment(new Date()),
    endDate: moment(new Date()),
  });

  const onRangeChange = (date: any) => {
    setFiltered(true);
    setFilters({
      ...filters,
      startDate: moment(new Date(date[0])),
      endDate: moment(new Date(date[1])),
      isAll: false,
    });
    setOption({
      id: 6,
      name: "Date Range",
      startDate: moment(new Date()),
      endDate: moment(new Date()),
    });
    stateHandler({
      filters: {
        ...filters,
        startDate: moment(new Date(date[0])),
        endDate: moment(new Date(date[1])),
        type: type?.value,
        isAll: false,
      },
    });
  };

  const options = [
    {
      id: 1,
      name: "Today",
      startDate: moment().startOf("day"),
      endDate: moment().endOf("day"),
    },
    {
      id: 2,
      name: "This Week",
      startDate: moment().startOf("week"),
      endDate: moment().endOf("week"),
    },
    {
      id: 3,
      name: "This Month",
      startDate: moment().startOf("month"),
      endDate: moment().endOf("month"),
    },
    {
      id: 4,
      name: "Year to Date",
      startDate: moment().startOf("year"),
      endDate: moment().endOf("month"),
    },
  ];

  const services = [
    { id: 1, value: "", name: "All" },
    { id: 2, value: "Periodic Service", name: "Periodic Service" },
    { id: 3, value: "Value Plus", name: "Value Plus" },
    { id: 4, value: "EM120", name: "Express Service (EM120)" },
    { id: 5, value: "Mechanical Repairs", name: "Mechanical Repairs" },
    { id: 6, value: "Body Shop Repairs", name: "Body Shop Repairs" },
    { id: 7, value: "Auto Valet", name: "Auto Valet" },
    {
      id: 8,
      value: "Wheel Alignment & Others",
      name: "Wheel Alignment & Others",
    },
    {
      id: 9,
      value: "Special Service Package (Engines up to 2500cc)",
      name: "Special Service Package (Engines up to 2500cc)",
    },
  ];

  const handleFetchAllSites = async () => {
    const data = await fetchAllSites();
    const sites = data?.payload.filter((item: any) => !item.isDealer);
    setSites(sites);
  };

  const sitecols = (
    <div className="">
      {sites?.map((item: any, index: number) => (
        <button
          onClick={() => siteHandler({ site: item })}
          className="flex flex-col border-b w-full py-1"
          key={index}
        >
          {item?.name}
        </button>
      ))}
    </div>
  );

  const rangeOptions = (
    <div>
      {options?.map((item: any, index: number) => (
        <div
          className="flex flex-col justify-start items-start w-full"
          key={index}
        >
          <button
            onClick={() => {
              setOption(item);

              if (item.id !== 1) {
                setFiltered(true);
                stateHandler({
                  filters: {
                    ...filters,
                    startDate: moment(new Date(item.startDate)),
                    endDate: moment(new Date(item.endDate)),
                    isAll: false,
                    type: type?.value,
                  },
                });
                setShowRange(true);
              } else {
                setFiltered(false);
                setShowRange(false);
                stateHandler({
                  filters: {
                    ...filters,
                    startDate: moment(new Date(item.startDate)),
                    endDate: moment(new Date(item.endDate)),
                    isAll: false,
                    type: type?.value,
                  },
                });
              }
            }}
            className="py-2 border-t focus:outline-none w-full flex items-start"
          >
            {item?.name}
          </button>
        </div>
      ))}
      {/* <div className="flex flex-col justify-start items-start w-full border-t-2">
        <button
          onClick={() => {
            setShowRange(true);
            setFiltered(true);
            setFilters({
              ...filters,
              startDate: moment(),
              endDate: moment(),
              isAll: true,
              type: type?.value,
            });
            setOption({
              id: 5,
              name: "All Bookings",
              startDate: moment(),
              endDate: moment(),
            });
            stateHandler({
              filters: {
                ...filters,
                startDate: moment(),
                endDate: moment(),
                isAll: true,
                type: type?.value,
              },
            });
          }}
          className="py-2 border-t focus:outline-none w-full flex items-start"
        >
          All Bookings
        </button>
      </div> */}
      <div className="flex flex-col justify-start items-start w-full border-t-2">
        <button
          onClick={() => clearDate()}
          className="p-2 border-t focus:outline-none w-full flex items-start border mt-2 bg-gray-50 text-red-500"
        >
          Clear Filters
        </button>
      </div>
    </div>
  );

  const servicesOptions = (
    <div>
      {services?.map((item: any, index: number) => (
        <div
          className="flex flex-col justify-start items-start w-full"
          key={index}
        >
          <button
            onClick={() => {
              setType(item);
              setFilters({ ...filters, type: item?.value });
              stateHandler({
                filters: {
                  ...filters,
                  type: item?.value,
                },
              });
            }}
            className="py-2 border-t focus:outline-none w-full flex items-start"
          >
            {item?.name}
          </button>
        </div>
      ))}

      <div className="flex flex-col justify-start items-start w-full border-t-2">
        <button
          onClick={() =>
            setType({ id: 1, name: "All Service Types", value: "" })
          }
          className="p-2 border-t focus:outline-none w-full flex items-start border mt-2 bg-gray-50 text-red-500"
        >
          Clear Filters
        </button>
      </div>
    </div>
  );

  const onDateChange = (date: any) => {
    setFiltered(true);
    stateHandler({
      filters: {
        ...filters,
        startDate: moment(new Date(date)),
        endDate: moment(new Date(date)),
        type: type?.value,
        isAll: false,
      },
      isRange: false,
    });
  };

  const clearDate = () => {
    form.resetFields();
    setFiltered(false);
    setOption({
      id: 1,
      name: "Today",
      startDate: moment(new Date()),
      endDate: moment(new Date()),
    });

    stateHandler({
      filters: {
        startDate: moment(new Date()),
        endDate: moment(new Date()),
        isAll: false,
        type: "",
      },
    });
  };

  useEffect(() => {
    handleFetchAllSites();
  }, []);

  return (
    <div className="block sm:flex justify-between items-center border-b border-gray-300 py-2 px-4 bg-white">
      <div className="flex">
        <Form layout="inline" form={form}>
          {showRange ? (
            <div className="flex justify-center items-center">
              <Form.Item name="ranger">
                <RangePicker
                  allowClear={true}
                  onChange={onRangeChange}
                  format={"DD-MM-YYYY"}
                />
              </Form.Item>
              <Checkbox onChange={() => setShowRange(!showRange)}>
                <span className="text-gray-500">Date as Range</span>
              </Checkbox>
            </div>
          ) : (
            <div className="flex justify-center items-center">
              <Form.Item name="picker">
                <DatePicker
                  onChange={onDateChange}
                  format={"DD-MM-YYYY"}
                  placeholder="Specific date"
                />
              </Form.Item>
              <Checkbox onChange={() => setShowRange(!showRange)}>
                <span className="text-gray-500">Date as Range</span>
              </Checkbox>
            </div>
          )}

          {isFiltered && (
            <Button
              className="flex items-center rounded-none ml-2 border-red-300 hover:bg-red-50 hover:border-red-400 text-red-500 bg-gray-50"
              onClick={() => clearDate()}
            >
              <div className="text-red-500">Clear Filters</div>
            </Button>
          )}
        </Form>
      </div>
      <div className="flex items-center">
        <Popover content={rangeOptions} title="" placement="bottom">
          <button className="flex items-center justify-center cursor-pointer focus:outline-none border border-red-300 py-1 px-4 bg-red-100">
            <div className="">{option?.name}</div>
            <div className="ml-1">
              <BsCaretDown />
            </div>
          </button>
        </Popover>

        <Popover content={servicesOptions} title="" placement="bottom">
          <button className="flex items-center justify-center cursor-pointer focus:outline-none border mx-1 border-red-300 py-1 px-4 bg-red-100">
            <div className="">{type?.name}</div>
            <div className="ml-1">
              <BsCaretDown />
            </div>
          </button>
        </Popover>

        {inManage && (
          <Popover content={sitecols} title="" placement="bottom">
            <button className="flex items-center justify-center cursor-pointer focus:outline-none border border-blue-300 py-1 px-4 bg-blue-100 mx-2">
              <div className="">{site?.name}</div>
              <div className="ml-1">
                <BsCaretDown />
              </div>
            </button>
          </Popover>
        )}
        <div className="flex justify-end">
          <ExportBooking bookings={bookings} />
          <CreateWrapper refetch={handleFetchBookings} />
          <Link
            to={`${
              inManage ? "/manage/bookings/calendar" : "/bookings/calendar"
            }`}
            className="border p-2 rounded-md ml-2"
          >
            <BsCalendar4Event color={"#323232"} size={25} />
          </Link>
        </div>
      </div>
    </div>
  );
}
